import React, { Component } from 'react';
import moment from 'moment';
import { Trash2 } from 'lucide-react';
import Modal from './Modal.js';
import './Modal.css';
import './NewAppointmentModal.css';

class NewAppointmentModal extends Component {
    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.props.onDetailsChange({ ...this.props.newAppointmentDetails, [name]: value });
    };

    render() {
        const {
            isOpen,
            onClose,
            onSave,
            onDelete,
            newAppointmentDetails,
            patients,
            selectedAppointment // For displaying selected appointment details in the modal
        } = this.props;

        if (!isOpen) return null;

        const patientName = selectedAppointment ? `${selectedAppointment.patient?.firstName} ${selectedAppointment.patient?.lastName}` : '';
        const appointmentDate = selectedAppointment ? moment(selectedAppointment.start).format('LL') : '';
        const appointmentTime = selectedAppointment ? moment(selectedAppointment.start).format('LT') : '';

        return (
            <Modal
                title={selectedAppointment ? "Edit Appointment" : "Create New Appointment"}
                onClose={onClose}
            >
                <div className="modal-body">
                    <div className="form-grid">
                        <div className="form-group full-width">
                            <label>Patient</label>
                            <select
                                name="patientId"
                                value={newAppointmentDetails.patientId}
                                onChange={this.handleInputChange}
                            >
                                <option value="">Please select a patient</option>
                                {patients.map(p => (
                                    <option key={p.id} value={p.id}>
                                        {p.firstName} {p.lastName} (ID: {p.nationalId})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Date</label>
                            <input
                                type="date"
                                name="date"
                                value={newAppointmentDetails.date}
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Time</label>
                            <input
                                type="time"
                                name="time"
                                value={newAppointmentDetails.time}
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="form-group full-width">
                            <label>Appointment Notes</label>
                            <textarea
                                name="notes"
                                value={newAppointmentDetails.notes}
                                onChange={this.handleInputChange}
                            ></textarea>
                        </div>
                    </div>
                    {selectedAppointment && (
                        <div className="appointment-info-display">
                            <strong>Patient:</strong> {patientName}<br />
                            <strong>Date:</strong> {appointmentDate} <br />
                            <strong>Time:</strong> {appointmentTime}
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    {selectedAppointment && (
                        <button
                            className="cancel-btn delete-btn" // Use cancel-btn style but custom class for delete
                            onClick={() => onDelete(selectedAppointment.id)}
                        >
                            <Trash2 size={16} /> Delete Appointment
                        </button>
                    )}
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="save-btn" onClick={() => onSave(newAppointmentDetails)}>
                        {selectedAppointment ? 'Update' : 'Save'}
                    </button>
                </div>
            </Modal>
        );
    }
}

export default NewAppointmentModal;
